import React from "react";
import MeetingListdata from "../../components/admin/MeetingList";
const MeetingListPage = () => {
  return (
    <div>
    <MeetingListdata />
    </div>
  );
};

export default MeetingListPage;
